module.exports = __webpack_public_path__ + "img/mail_list.a3fef2b6.png";